import { render, staticRenderFns } from "./Navigate.vue?vue&type=template&id=38e37b80&scoped=true"
import script from "./Navigate.vue?vue&type=script&lang=js"
export * from "./Navigate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e37b80",
  null
  
)

export default component.exports